import { Link } from "react-router-dom";
import "../styles/report.css";
import "../styles/reportPrint.css";
import { META, FRAMING } from "../data/reportContent";
import { ExecSummaryBody } from "../components/report/ExecSummaryBody";

export default function ExecutiveSummaryPrint() {
  return (
    <div className="report-root print-mode exec-print" data-testid="execsummary-print-page">
      <div className="print-toolbar no-print" data-testid="execsummary-print-toolbar">
        <div>
          <Link to="/executive-summary" className="btn-ghost" data-testid="execsummary-print-back-link">
            ← Back to executive summary
          </Link>
        </div>
        <div className="print-toolbar-actions">
          <span className="print-toolbar-note">
            For a clean PDF, keep “Headers and footers” switched OFF in your browser’s print dialog; page numbers are already built into this document.
          </span>
          <button className="btn-primary" onClick={() => window.print()} data-testid="execsummary-print-now-button">
            Print / Save PDF
          </button>
        </div>
      </div>

      <div className="report-container">
        <header className="exec-print-header" data-testid="execsummary-print-header">
          <span className="report-kicker">{META.edition} · {META.date} · Executive Summary, Print Edition</span>
          <h1 data-testid="execsummary-print-title">{META.title}</h1>
          <p className="subtitle">Executive Summary</p>
          <p className="framing" data-testid="execsummary-print-framing">{FRAMING}</p>
        </header>
      </div>

      <ExecSummaryBody />

      <footer className="report-footer" data-testid="execsummary-print-report-footer">
        <span>{META.title}: Executive Summary</span>
        <span>{META.edition} · {META.date}</span>
        <span>{META.provenance}</span>
        <span data-testid="execsummary-print-copyright">{META.copyright}</span>
      </footer>
    </div>
  );
}
